import React from 'react';

const NotFoundPage = React.lazy(() => import('./components/NotFoundPage/NotFoundPage'));
const GalleryPage = React.lazy(() => import('./containers/GalleryPage'));
const CreditsPage = React.lazy(() => import('./containers/CreditsPage'));
const PaymentPage = React.lazy(() => import('./containers/PaymentPage'));

const StoreUsersPage = React.lazy(() => import('./containers/StoreUsersPage'));
const StoreNetworkPage = React.lazy(() => import('./containers/StoreNetworkPage'));

export { NotFoundPage, CreditsPage, GalleryPage, PaymentPage, StoreUsersPage, StoreNetworkPage };
